const {h, render, Component} = require('preact');
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const queryString = require('qs');
const SpinnerView = require('../../views/common/spinner')
const Search = require('./search')
const Helper = require('./helper')
const SearchResults = require('./search_results')
const FrontEndHelper = require('../../../helper')
const ContextualArticlesResults = require('./contextual_articles_results')
const {route} = require('preact-router')

class ContextualArticles extends Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
    }

    getinbentaChannelCategoryIds() {
        return Groupon.Utils.getConfigFromDom().inbentaChannelCategoryIds
    }

    componentDidMount() {
        let dealType = this.props.inbentaParams.dealType;
        let topLevelDealType = FrontEndHelper.getDealType(dealType);
        if (topLevelDealType === "NOTFOUND") {
            this.setState({contextualArticleResults : null});
        }
        else {
            let inbentaChannelCategoryIds = this.getinbentaChannelCategoryIds();
            if(topLevelDealType === "LOCAL") {
                let dealId = this.props.inbentaParams.dealId
                let costcoPermalinkPattern = Groupon.Utils.getConfigFromDom().costcoPermalinkPattern
                if( dealId && costcoPermalinkPattern && dealId.includes(costcoPermalinkPattern))
                    topLevelDealType = "COSTCO"
            }
            let categoryId = inbentaChannelCategoryIds[topLevelDealType];
            let inbentaParams = this.props.inbentaParams;
            inbentaParams.categoryId = categoryId;
            inbentaParams.page = 0;
            let qs = queryString.stringify(inbentaParams);
            let CONTEXTUAL_ARTICLES = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/contextual_articles?${qs}`;
            let errorCb = () => {
                this.setState({contextualArticleResults: null, isFetching: false, 'isFailure': true});
            }
            let successCb = (response) => {
                if (response) {
                    this.setState({contextualArticleResults: response, isFetching: false});
                }
            }
            this.setState({contextualArticleResults: null, isFetching: true})
            SupportAPIHelper.get(CONTEXTUAL_ARTICLES, null, successCb, errorCb, false);
        }
    }

    handleSearch(searchText){
        let inbentaParams = this.props.inbentaParams;
        Groupon.inbentaParams = inbentaParams

        let queryParams = {
            claimId: this.props.claimId,
            orderId: this.props.orderId,
            searchText: searchText
        }
        let qs = queryString.stringify(queryParams);
        route(`/customer_support/web/summary/search?${qs}`);
    }

    render() {
        let contextualArticlesResultComponent = null;
        Helper.closeOpenedArticles();

        // Reusing the results component for showing contextual Articles

        if (this.state.contextualArticleResults){
            contextualArticlesResultComponent = <ContextualArticlesResults
                results={this.state.contextualArticleResults.result}
                handleNeedHelpFromSearchResults={this.props.handleNeedHelpFromSearchResults}
            />;
        }
    return (
        <div>
            <p class="contextual-search-bar-above-text">
                {I18n.translate("js.modules.web_2018.need_help_with_this_groupon")}
            </p>
            <Search handleSearch = {this.handleSearch.bind(this)}/>
            {contextualArticlesResultComponent}
            {this.state.isFetching && <SpinnerView/>}
        </div>
        )
    }
}

module.exports = ContextualArticles